<template>
  <v-dialog
    :fullscreen="$vuetify.display.xs"
    max-width="1400px"
    :model-value="show"
    @update:model-value="$emit('update:show', $event)"
  >
    <v-card>
      <div class="card-top p-2">
        <span class="card-title">CSV Preview</span>
        <v-btn style="border-radius: 100px" @click="$emit('update:show', false)" icon size="large"
          ><v-icon>mdi-close</v-icon></v-btn
        >
      </div>

      <div class="card-body">
        <div :class="['validation-status', { invalid: !validation.valid }]">
          <v-icon :color="validation.valid ? 'rgb(4, 231, 4)' : 'rgb(255, 0, 0)'">{{
            validation.valid ? "mdi-check-decagram" : "mdi-close-circle"
          }}</v-icon>
          <span>
            {{ validation.valid ? "File is Valid" : "File is Invalid" }}
          </span>
        </div>
        <div class="error-list" v-if="!invalidFields.valid">
          <template v-for="(message, i) in invalidFields.validMessages" :key="i">
            <div :class="`${message.type}-item`">
              {{ message.message }}
            </div>
          </template>
        </div>
        <PreviewTable :csv-type="csvType" :file-str="fileStr"></PreviewTable>
      </div>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { validateCsv } from "./utils";
import PreviewTable from "./previewTable.vue";

type TCsvType = { name: string; fields: string[]; title: string; fileName: string };
const props = defineProps<{
  fileStr: string;
  validation: {
    valid: boolean;
    validMessages: {
      type: "error" | "warning";
      message: string;
    }[];
  };
  show: boolean;
  csvType: TCsvType;
}>();

defineEmits<{
  (event: "update:show", vaL: boolean): void;
}>();

const invalidFields = computed(() => {
  return validateCsv(props.fileStr, props.csvType, true);
});
</script>

<style scoped lang="scss">
@use "@/assets/_vars.scss" as *;
@use "@/assets/_breakpoints.scss" as breakpoints;
@use "sass:map";

.no-col-header {
  border-right: 1px solid #cfcebb !important;
}
.no-col {
  border-right: 1px solid #e5e4db !important;
  width: 0;
  text-align: center;
}
.error-item {
  color: rgb(255, 0, 0);
}

.warning-item {
  color: #ff9200;
}
.validation-status {
  user-select: none;
  background-color: $gray-50;
  padding: 10px 30px;
  margin-top: 10px;
  margin-bottom: 10px;
  border-radius: 4px;
  border: 1px solid $gray-200;

  color: rgb(4, 231, 4);
  display: flex;
  align-items: center;
  gap: 10px;
  width: fit-content;

  &.invalid {
    color: rgb(255, 0, 0);
  }
}

.card-body {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.card-top {
  display: flex;
  align-items: center;
  background-color: $primary;
  min-width: 100%;
  justify-content: space-between;
  .card-title {
    font-weight: 600;
    font-size: 1.25rem;
    margin: auto 0 auto 20px;
    color: white;
  }
}

.scrollable-55vh {
  max-height: 55vh;
  overflow: auto;
  margin-top: 1rem; // Instead of @extend .mt-3
  .table {
    margin-top: 0; // Instead of @extend .mt-0
  }
}

.table-overflow-hide {
  overflow: hidden;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  margin-top: 1rem; // Instead of @extend .mt-3
  .scrollable-55vh {
    margin-top: 0; // Instead of @extend .mt-0
    .table {
      margin-top: 0; // Instead of @extend .mt-0
    }
  }

  border: solid 1px $gray-300;
  .directoryTable {
    border: unset;
  }
}
.directoryTable {
  overflow-x: auto; // Instead of @extend .table-responsive
  border: solid 1px $gray-300;

  table {
    margin-top: 1rem; // Instead of @extend .mt-3
    width: 100%; // Instead of @extend .table
    background-color: white; // Instead of @extend .bg-white
    margin-bottom: 0; // Instead of @extend .mb-0

    thead th {
      font-weight: $font-weight-medium;
      white-space: nowrap;
      color: $gray-600;
      font-size: 0.75rem;
      text-transform: uppercase;
      letter-spacing: 0.075em;
    }
    tbody {
      border-top: none !important;
      td {
        vertical-align: middle;
      }
      td:first-child {
        width: 28px;
      }
      td:nth-child(2) {
        width: 250px;
      }
    }
    .icon {
      width: 75px;
      height: 25px;
    }
    > :not(caption) > * > * {
      background-color: unset; //remove BS default
    }
  }
  + h3 {
    margin-top: 3rem;
  }

  .sticky-header tr {
    position: sticky;
    top: 0;
    background-color: $gray-200;
    z-index: 1; /* Increase the z-index value */
    th {
      // color: $white !important;
      font-size: medium !important;
      font-size: 0.85rem;
      // padding: unset;
      vertical-align: middle;
      // text-align: center;
    }
  }
  border-collapse: separate;
  border-spacing: 0;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
</style>
